import { uuid } from 'uuidv4';
import { get } from 'svelte/store';
import { user } from '../store.js';
import { db } from './config.js';
import { Role } from '../constants.js';
import moment from 'moment';

export const upsertResident = async (resident) => {
  if (!resident.resident_id) {
    resident.resident_id = uuid();
    resident.account_id = get(user).account_id;
  }
  return await db.collection('residents').doc(resident.resident_id).set(resident);
}

export const upsertAccount = async (account) => {
  if(!account.account_id) {
    account.account_id = uuid();
  }
  const accountToUnix = {...account, last_reset: moment(account.last_reset).unix()};
  return await db.collection('users').doc(accountToUnix.account_id).set(accountToUnix);
}

export const batchUpsertResidents = async (residents) => {
  const batch = db.batch();
  residents.forEach((resident) =>  {
    if (!resident.resident_id) {
      resident.resident_id = uuid();
      resident.account_id = get(user).account_id;
    }
    batch.set(db.collection('residents').doc(resident.resident_id), resident);
  });
  return await batch.commit();
}

export const batchDeleteResidents = async (residents) => {
  const batch = db.batch();
  residents.forEach((resident) => {
    batch.delete(db.collection('residents').doc(resident.resident_id));
  });
  return await batch.commit();
}

export const deleteResidents = async (account_id) => {
  await db.collection('residents').where('account_id', '==', account_id).delete();
}

export const deleteResident = async (resident) => {
  await db.collection('residents').doc(resident.resident_id).delete();
  return resident;
}

export const loadResidents = async () => {
  let data = [];
  const accountID = get(user).account_id;
  const results = await db.collection('residents')
    .where('account_id', '==', get(user).account_id)
    .get();
  results.forEach(doc => data.push(doc.data()))
    
  return data;
}

// export const updateUser = async (user) => {
//   return await db.collection('users').doc(user.account_id).set(user);
// }

export const loadAccounts = async () => {
  let data = [];
  const results = await db.collection('users')
    .get();
  results.forEach(doc => data.push(doc.data()));
  return data
    .filter(account => account.account_id !== get(user).account_id)
    .map(account => ({...account, last_reset: moment.unix(account.last_reset).format('YYYY-MM-DD')}))
}

export const loadAlerts = async () => {
  let data = [];
  const results = await db.collection('alert-stats')
    .where('account_id', '==', get(user).account_id)
    .get();
  results.forEach(doc => data.push(doc.data()));
  return data;
}

export const loadReportAlerts = async ( { account_id, company, included_alerts, last_reset }, fromDate) => {
  let data = [];
  const lastResetUnix = moment(last_reset, 'YYYY-MM-DD').unix();
  const cleanedLastReset = isNaN(lastResetUnix) ? moment('2000-01-01', 'YYYY-MM-DD').unix() : lastResetUnix;

  const results = await db.collection('alert-stats')
    .where('account_id', '==', account_id)
    .where('created', '>', cleanedLastReset)
    .get();
  results.forEach(doc => data.push(doc.data()));
  return {
    account_id,
    company,
    included_alerts,
    last_reset,
    alerts: data
  };
}

export const deleteUserAccount = async (account_id) => {
  await db.collection('users').doc(account_id).delete();
}

export const deleteResidentAccounts = async (account_id) => {
  const residentAccounts = await db.collection('residents').where('account_id', '==', account_id).get();
  let batch = db.batch();
  let count = 0;

  residentAccounts.forEach(residentAccount => {
    batch.delete(residentAccount.ref);
    count++;
    if (count >= 250) {
      batch.commit();
      count = 0;
      batch = db.batch();
    }
  });
  if (batch.length) batch.commit();
}

export const insertAlertStats = async (alertStats) => {
  return await db.collection('alert-stats').add(alertStats);
}

export const insertAlertDetails = async (docId, alertDetails) => {
  return await db.collection('alert-stat-details').doc(docId).set({alertDetails});
}
